import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

export const getEncabezadosIngresosHilaza= async(dates) =>{
    const result = await PrivateInterceptor(`Inventario/Hilaza/IngresosHilaza/FechasEncabezado`, 'POST', {Fecha1 :dates[0], Fecha2: dates[1]})
    return result
}

export const getInformacionIngresosHilaza = async(informacion) =>{
    const result = await PrivateInterceptor(`Inventario/Hilaza/IngresosHilaza/InformacionIngreso`, 'POST', informacion)
    return result
}

export const postGenerarEncabezadoHilaza = async(informacionDetalles) =>{
    const result = await PrivateInterceptor(`Inventario/Hilaza/IngresosHilaza/GenerarEncabezadoHilaza`, 'POST', {Detalles:informacionDetalles})
    return result
}